/**
 * Helper function to determine if a camp can have the new talent card selection
 * Only camps ending on or after September 1, 2025 can have the selection
 */
export const canSelectTalentCardType = (campEndDate: string | null | undefined): boolean => {
  if (!campEndDate) return false

  const endDate = new Date(campEndDate)
  const season2526Cutoff = new Date('2025-09-01')

  return endDate >= season2526Cutoff
}

/**
 * Determines which talent card component to use based on camp selection
 */
export const usesNewTalentCardComponent = (camp: any): boolean => {
  // For camps that can't have selection, always use old card
  if (!canSelectTalentCardType(camp?.end)) {
    console.log('🎯 Camp cannot select talent card type, using old card', camp?.end)
    return false
  }

  // For newer camps, check the talentCardType selection
  const talentCardType = camp?.talentCardType
  console.log('🎯 TalentCardType:', talentCardType, 'Using new card:', talentCardType === '25' || talentCardType === '25_with_bg')
  return talentCardType === '25' || talentCardType === '25_with_bg'
}

/**
 * Determines which participant image to use based on camp settings
 * For old camps or camps with standard talent card, prefer imageWithBackground
 * For new camps with "25" (freigestellt), use the processed image
 * For new camps with "25_with_bg", use imageWithBackground
 */
export const getParticipantImageUrl = (participant: any, camp: any): string | null | undefined => {
  // Filter out default talent card images
  const filterDefaultImage = (url: string | null | undefined) => {
    return url?.includes('default_talentcard.png') ? null : url
  }

  console.log('🖼️ getParticipantImageUrl:', {
    participantId: participant?.id,
    image: participant?.image,
    imageWithBackground: participant?.imageWithBackground,
    campEnd: camp?.end,
    talentCardType: camp?.talentCardType
  })

  // Check if participant has imageWithBackground (Participant type has it, SpecialTalent doesn't)
  const hasImageWithBackground = 'imageWithBackground' in participant

  // For old camps (before Sept 1, 2025), always prefer imageWithBackground
  if (!canSelectTalentCardType(camp?.end)) {
    return filterDefaultImage(
      hasImageWithBackground ? (participant.imageWithBackground ?? participant.image) : participant.image
    )
  }

  // For newer camps, check the talentCardType selection
  const talentCardType = camp?.talentCardType

  // Only "25" (freigestellt) should use the processed image without background
  if (talentCardType === '25') {
    return filterDefaultImage(
      participant.image ?? (hasImageWithBackground ? participant.imageWithBackground : null)
    )
  }

  // For all other cases (undefined, empty string, "25_with_bg", or "24/25"),
  // prefer imageWithBackground and fall back to image
  return filterDefaultImage(
    hasImageWithBackground ? (participant.imageWithBackground ?? participant.image) : participant.image
  )
}
